import script from "./digitalWallet.vue?vue&type=script&setup=true&lang=js"
export * from "./digitalWallet.vue?vue&type=script&setup=true&lang=js"

import "./digitalWallet.vue?vue&type=style&index=0&id=627a1366&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-627a1366"]])

export default __exports__